import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Lenis from "lenis";
import "@/App.css";
import { LanguageProvider } from "@/context/LanguageContext";
import { Navbar } from "@/components/site/Navbar";
import { WhatsAppButton } from "@/components/site/WhatsAppButton";
import { CookieBanner } from "@/components/site/CookieBanner";
import { Preloader } from "@/components/site/Preloader";
import Home from "@/pages/Home";
import BoatPage from "@/pages/BoatPage";
import Privacy from "@/pages/Privacy";

function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.1, smoothWheel: true, autoRaf: true });
    window.lenis = lenis;
    return () => {
      lenis.destroy();
      delete window.lenis;
    };
  }, []);

  return (
    <LanguageProvider>
      <BrowserRouter>
        <Preloader />
        <div className="App min-h-screen bg-canvas selection:bg-navy selection:text-canvas">
          <Navbar />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/barca/:slug" element={<BoatPage />} />
            <Route path="/privacy" element={<Privacy />} />
          </Routes>
          <WhatsAppButton />
          <CookieBanner />
        </div>
      </BrowserRouter>
    </LanguageProvider>
  );
}

export default App;
